import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { setGlobalFilterChangePending } from '@/features/users';

interface Filters {
  adGroup: {
    id: string;
    nameAndId: string;
    highlightedParts?: { text: string; highlight: boolean }[];
  } | null;
}

interface StarvationBidderState {
  filters: Filters;
}

const initialState: StarvationBidderState = {
  filters: {
    adGroup: null,
  },
};

const starvationBidderSlice = createSlice({
  name: 'starvationBidder',
  initialState,
  reducers: {
    setAdGroupFilter(
      state,
      action: PayloadAction<typeof initialState.filters.adGroup>
    ) {
      state.filters.adGroup = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(setGlobalFilterChangePending, (state, action) => {
      if (action.payload) {
        // Reset filters to initial state when global filters change, to avoid showing stale data
        state.filters = initialState.filters;
      }
    });
  },
});

export const starvationBidderAdgroupFilterSelector = (state: {
  starvationBidder: StarvationBidderState;
}) => state.starvationBidder.filters.adGroup;

export const { setAdGroupFilter } = starvationBidderSlice.actions;

export default starvationBidderSlice.reducer;
